import React from 'react'

const SigninPage = () => {
  return (
    <div>
        <h1>Sign in page</h1>
    </div>
  )
}

export default SigninPage